import React from "react";
import queryString from "query-string";
import { Redirect } from 'react-router-dom';

import { getLanguageFromCulture } from "../../helpers";
import { sessionService } from "../../state/ducks/session/sessionService";

export default function PaymentPage(props) {

  const culture = sessionService.getCulture();
  const lng = getLanguageFromCulture(culture);

  //parameters in the query string are:
  //code: the code returned by the payment gateway:
  //  empty: success
  //  1002: payment error
  //  other: payment failed, retry
  //reference: the reference returned by the payment gateway, to be checked against the reference sent to the gateway
  //gateway: the name of the payment gateway used, to be used in the confirmation page
  //status: the status of the payment, to be used in the confirmation page
  //  pending: the payment is pending, waiting for the payment gateway to confirm the payment
  const params = queryString.parse(props.location.search);

  const payment = {
    code: params.code,
    reference: params.reference,
    gateway: params.gateway,
    status: params.status,
  };

  let pathname;
  let search;

  // no error
  if (!params.code) {
    if (params.paytype === 'travelvoucher') {
      pathname = `/${lng}/voucher/confirmation`;
    } else {
      const bookingMode = sessionService.getBookingMode();
      if (bookingMode?.mode === 'MMB') {
        pathname = `/${lng}/mmb/summary`;
      } else if (bookingMode?.mode === 'WCI') {
        pathname = `/${lng}/wci/confirmation`;
      } else {
        pathname = `/${lng}/confirmation`;
      }
    }
  }
  // payment error
  else if (params.code === '1002') {
    pathname = `/${lng}/payment-error`;
    search = props.location.search;
  }
  // other errors
  else {
    pathname = params.paytype === 'travelvoucher' ? `/${lng}/voucher` : `/${lng}/checkout`;
  }

  return <Redirect to={{ pathname, search, state: { payment } }} />;
}
